import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
const content = {
  de: {
    title: 'Impressum',
    addressHeading: 'Adresse',
    contactHeading: 'Kontakt',
    representative: 'Vertreten durch: Justus Kraft',
    phone: 'Telefon: +49 157 35999071',
    email: 'E-Mail: justus@crm-kraft.de',
    disputeHeading: 'EU-Streitschlichtung',
    disputeBeforeLink: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:',
    disputeAfterLink: 'Unsere E-Mail-Adresse finden Sie oben im Impressum.',
    consumerHeading: 'Verbraucherstreitbeilegung/Universalschlichtungsstelle',
    consumerText: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
  },
  en: {
    title: 'Imprint',
    addressHeading: 'Address',
    contactHeading: 'Contact',
    representative: 'Represented by: Justus Kraft',
    phone: 'Phone: +49 157 35999071',
    email: 'Email: justus@crm-kraft.de',
    disputeHeading: 'EU Online Dispute Resolution',
    disputeBeforeLink: 'The European Commission provides a platform for online dispute resolution (ODR):',
    disputeAfterLink: 'You can find our email address above in this imprint.',
    consumerHeading: 'Consumer Dispute Resolution / Universal Arbitration Board',
    consumerText: 'We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.'
  }
};
export function ImpressumPage() {
  const {
    language
  } = useLanguage();
  const t = content[language];
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-573">
      <Navigation data-id="element-574" />
      <main className="pt-24 pb-16" data-id="element-575">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-576">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-577">{t.title}</h1>

          <div className="prose prose-invert max-w-none" data-id="element-578">
            <section className="mb-8" data-id="element-579">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-580">
                {t.addressHeading}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-581">
                CRM Kraft LLC
                <br data-id="element-582" />
                {t.representative}
                <br data-id="element-583" />
                7901 4th St. N, Ste. 300
                <br data-id="element-584" />
                St. Petersburg, FL 33702
                <br data-id="element-585" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-586">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-587">
                {t.contactHeading}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-588">
                {t.phone}
                <br data-id="element-589" />
                {t.email}
              </p>
            </section>

            <section className="mb-8" data-id="element-590">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-591">
                {t.disputeHeading}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-592">
                {t.disputeBeforeLink}{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-593">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-594" />
                {t.disputeAfterLink}
              </p>
            </section>

            <section data-id="element-595">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-596">
                {t.consumerHeading}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-597">{t.consumerText}</p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-598" />
    </div>;
}